import _axios from "@/plugins/axios";
import Axios from "axios";

export default {
  namespaced: true,
  state: {
    _list_group_color: null,
    _list_group_color_student: null,
    _list_news: null,
    _list_Feed_Facebook: null,
    _list_teacher: null,
  },
  getters: {
    _list_group_color: (state) => state._list_group_color,
    _list_group_color_student: (state) => state._list_group_color_student,
    _list_news: (state) => state._list_news,
    _list_Feed_Facebook: (state) => state._list_Feed_Facebook,
    _list_teacher: (state) => state._list_teacher,
    _list_news_type: (state) => state._list_news_type,
  },
  mutations: {},
  actions: {
    //-----------------List Data
    _list_news(context, param) {
      return _axios.post("/information/_list_news", param).then((res) => {
        context.state._list_news = res.data;
        return res.data;
      });
    },
    _list_Feed_Facebook(context) {
      const urlFeed =
        "https://script.google.com/macros/s/AKfycbwLPLvENRkMqOsVMzHVQmG5jCw-jHgVCQMe2l2LIn4aRYFmJwev3dNW7TgjvkszAl4N/exec";
      Axios.get(urlFeed).then((res) => {
        context.state._list_Feed_Facebook = res.data;
      });
    },
    _list_group_color(context, param) {
      return _axios
        .post("/information/_list_group_color", param)
        .then((res) => {
          context.state._list_group_color = res.data;
          return res.data;
        });
    },
    _list_group_color_student(context, param) {
      return _axios
        .post("/information/_list_group_color_student", param)
        .then((res) => {
          context.state._list_group_color_student = res.data;
          return res.data;
        });
    },
    _list_news_type(context) {
      _axios.get("/information/_list_news_type").then((res) => {
        context.state._list_news_type = res.data;
      });
    },
    _list_teacher(context) {
      _axios.get("/information/_list_teacher").then((res) => {
        context.state._list_teacher = res.data;
      });
    },
    _check_user_website(context) {
      return _axios.get("/user_website/_checkUserWebsite").then((res) => res);
    },
    //-----------------List Data
    //-----------------Insert Data
    _insert_news(context, params) {
      return _axios
        .post("/information/_insert_news", params, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => res.data);
    },
    _insert_group_color(context, params) {
      return _axios
        .post(
          "/information/_insert_group_color",
          params
          // , {
          // headers: {
          //   "Content-Type": "multipart/form-data",
          // },
          // }
        )
        .then((res) => res.data);
    },
    //-----------------Insert Data
    //-----------------Edit Data
    _edit_group_color(context, params) {
      return _axios
        .post(
          "/information/_edit_group_color",
          params
          // , {
          // headers: {
          //   "Content-Type": "multipart/form-data",
          // },
          // }
        )
        .then((res) => res.data);
    },
    //-----------------Edit Data
    //-----------------Delete Data
    _delete_group_color(context, params) {
      return _axios
        .post(
          "/information/_delete_group_color",
          params
          // , {
          // headers: {
          //   "Content-Type": "multipart/form-data",
          // },
          // }
        )
        .then((res) => res.data);
    },
    _delete_news(context, params) {
      return _axios
        .post(
          "/information/_delete_news",
          params
          // , {
          // headers: {
          //   "Content-Type": "multipart/form-data",
          // },
          // }
        )
        .then((res) => res.data);
    },
    //-----------------Delete Data
  },
  modules: {},
};
